module.exports = __webpack_public_path__ + "img/pic1@3x.b2d32774.png";